import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class EquationService {

  static createEquation(metricId,body) {
    return HttpUtil.post(API_ROUTES.EQUATIONDATA.SAVEDATA.replace("<metricId>", metricId), body);
  }

  static updateTask(taskId, payload) {
    return HttpUtil.put(API_ROUTES.TASK.UPDATE_TASK.replace("<taskId>", taskId), payload);
  }

  static getEquationConfig(standardId,metricId,topicId,forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.get(API_ROUTES.EQUATIONDATA.GETCONFIG_ADMIN.replace("<standardId>", standardId)
      .replace("<metricId>", metricId)
      .replace("<topicId>", topicId), {});
    }
    else{
      return HttpUtil.get(API_ROUTES.EQUATIONDATA.GETCONFIG.replace("<standardId>", standardId)
      .replace("<metricId>", metricId)
      .replace("<topicId>", topicId), {});
    }
    }

  static getEquationExecutionStatus(companyId) {
    return HttpUtil.get(API_ROUTES.EQUATIONDATA.EXECUTION_STATUS.replace("<companyId>", companyId), {});
  }
   
  static getEquationComponents(standardId, eqId) {
    return HttpUtil.get(
      API_ROUTES.EQUATIONDATA.GET_COMPONENTS
        .replace("<standardId>", standardId)
        .replace("<eqId>", encodeURIComponent(eqId)),
      {}
    );
  }
}
